import CloseIcon from "@mui/icons-material/Close";
import {
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    IconButton,
    TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import {
    isValidPortalEmail,
    normalizePortalEmail,
} from "./commercePortalAccess";

export default function CommercePortalAccessModal({
    commerce,
    loading,
    onClose,
    onSubmit,
    open,
}) {
    const [portalEmail, setPortalEmail] = useState("");
    const [validationAttempted, setValidationAttempted] = useState(false);

    useEffect(() => {
        if (open) {
            setPortalEmail(
                typeof commerce?.portalEmail === "string"
                    ? commerce.portalEmail
                    : ""
            );
            setValidationAttempted(false);
        }
    }, [commerce?.portalEmail, commerce?.uuid, open]);

    const normalizedPortalEmail = normalizePortalEmail(portalEmail);
    const validationMessage = !normalizedPortalEmail
        ? "El correo es obligatorio"
        : !isValidPortalEmail(normalizedPortalEmail)
            ? "Ingresa un correo válido"
            : "";
    const showValidationError = validationAttempted && Boolean(validationMessage);

    const handleClose = () => {
        if (!loading) {
            onClose();
        }
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        setValidationAttempted(true);
        if (!validationMessage) {
            onSubmit(normalizedPortalEmail);
        }
    };

    return (
        <Dialog
            aria-labelledby="commerce-portal-access-dialog-title"
            fullWidth
            maxWidth="sm"
            onClose={handleClose}
            open={open}
        >
            <form noValidate onSubmit={handleSubmit}>
                <DialogTitle id="commerce-portal-access-dialog-title">
                    Habilitar acceso al portal
                    <IconButton
                        aria-label="Cerrar"
                        disabled={loading}
                        onClick={handleClose}
                        sx={{
                            position: "absolute",
                            right: 8,
                            top: 8,
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText sx={{ mb: 2 }}>
                        Comercio: {commerce?.name || "Sin nombre"}
                    </DialogContentText>
                    <TextField
                        autoFocus
                        disabled={loading}
                        error={showValidationError}
                        fullWidth
                        helperText={showValidationError ? validationMessage : ""}
                        label="Correo del usuario del comercio"
                        onChange={(event) => setPortalEmail(event.target.value)}
                        required
                        type="email"
                        value={portalEmail}
                    />
                </DialogContent>
                <DialogActions>
                    <Button disabled={loading} onClick={handleClose}>
                        Cancelar
                    </Button>
                    <Button
                        aria-label="Habilitar acceso"
                        disabled={loading}
                        type="submit"
                        variant="contained"
                    >
                        {loading ? (
                            <CircularProgress color="inherit" size={18} />
                        ) : (
                            "Habilitar acceso"
                        )}
                    </Button>
                </DialogActions>
            </form>
        </Dialog>
    );
}
